/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://mfy2fgzdxrf5de4idz7336m4tm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-f62tzshrsbe4rbzdnsgcobcv3q",
    "aws_cognito_identity_pool_id": "us-east-1:7cf92dce-3f47-4f83-b97d-031927c57e6b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ESwBZvYRp",
    "aws_user_pools_web_client_id": "40kdsh3kuanmdb7lv2lkklvtob",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "afi-web-s3-bucket114851-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
